<template>
	<v-dialog :value="true" persistent max-width="600px">
		<v-card>
			<v-toolbar flat dense>
				<v-toolbar-title class="subheading">Mark Policy as Reviewed</v-toolbar-title>
			</v-toolbar>

			<v-card-text>
				<v-subheader class="mt-2 mb-4 text-xs-left pl-0">
					Marking a policy as reviewed means you've assessed the policy and confirmed it is still current and accurate. This does not notify {{ $term('employee', { plural: true }) }} or require new acknowledgements unless the policy itself is updated.
				</v-subheader>

				<v-select v-model="employeeSelected" class="mt-4" :items="employees" :error-messages="employeeIdErrors" item-text="fullName" return-object label="Reviewed By" required></v-select>

				<v-menu ref="dueDateMenu" v-model="form.reviewDateUTC.menu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="form.reviewDateUTC.date" lazy transition="scale-transition" offset-y full-width min-width="290px">
					<v-text-field slot="activator" v-model="reviewDateFormatted" label="Review Date" readonly></v-text-field>
					<v-date-picker v-model="form.reviewDateUTC.date" @input="$refs.dueDateMenu.save(form.reviewDateUTC.date)" :max="today"></v-date-picker>
				</v-menu>
				<v-textarea ref="notes" v-model="form.notes" auto-grow box rows="3" label="Notes"></v-textarea>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="onCancelClick">Cancel</v-btn>
				<v-btn flat color="primary" :loading="isSaving" :disabled="isSaving" @click="onSave">
					Save
					<span slot="loader">Saving...</span>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import toast from '@/services/toasts/index.js';

	export default {
		mixins: [validationMixin],
		props: {
			id: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				form: {
					reviewDateUTC: {
						date: this.$options.filters.formatDate(new Date(), 'YYYY-MM-DD'),
						menu: false
					},
					reviewedByEmployeeId: null,
					notes: null
				},
				isSaving: false
			};
		},
		created() {
			this.form.reviewedByEmployeeId = this.loggedInEmployee.id;
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				employees: 'employees/employeesMiniActiveOnly'
			}),
			reviewDateFormatted() {
				return this.$options.filters.formatDate(this.form.reviewDateUTC.date);
			},
			employeeSelected: {
				get() {
					return this.employees.find(x => x.id === this.form.reviewedByEmployeeId);
				},
				set(val) {
					this.form.reviewedByEmployeeId = val.id;
				}
			},
			employeeIdErrors() {
				const errors = [];
				if (!this.$v.form.reviewedByEmployeeId.$dirty) return errors;
				!this.$v.form.reviewedByEmployeeId.required && errors.push('Reviewed By is required.');
				return errors;
			},
			today() {
				return this.$options.filters.formatDate(new Date(), 'YYYY-MM-DD');
			}
		},
		validations: {
			form: {
				reviewedByEmployeeId: { required }
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.$refs.notes.focus();
			});
		},
		methods: {
			onCancelClick() {
				this.$emit('onCancel');
			},
			async onSave() {
                const selectedDate = this.form.reviewDateUTC.date;

				const payload = {
					id: this.id,
					reviewDateUTC: selectedDate === this.today ? null : selectedDate,
					reviewedByEmployeeId: this.form.reviewedByEmployeeId,
					notes: this.form.notes
				};

				this.isSaving = true;

				this.$store
					.dispatch('hrDocuments/addReview', payload)
					.then(response => {
						toast.success('Policy marked as reviewed.');
						this.$emit('onReviewed');
					})
					.finally(() => {
						this.isSaving = false;
					});
			}
		}
	};
</script>

<style scoped></style>
